import React, { ReactNode } from "react";

interface FrameProps {
  children: ReactNode;
}

const Frame = ({ children }: FrameProps) => (
  <header className="hero">{children}</header>
);

export default Frame;
